import { render, staticRenderFns } from "./PartnerdatenForm.vue?vue&type=template&id=02a2db8d&"
import script from "./PartnerdatenForm.vue?vue&type=script&lang=js&"
export * from "./PartnerdatenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports